define.alias("shared/components/shared/social/refresh-profile/twitter", "calendar/components/shared/social/refresh-profile/twitter");